"use client";

import React, { ButtonHTMLAttributes } from "react";
import { usePathname } from "next/navigation";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../ui/tooltip";
import { Button, ButtonProps } from "../ui/button";
import { useRouter } from "@/lib/utils/router-events";
import { Routes_Dashboard } from "@/config/page-routes";

export interface SidebarMenuProps extends ButtonProps {
  menuItemName: string;
  menuIcon: any;
  menuItemPagePath: Routes_Dashboard;
}

const SidebarMenu = React.forwardRef<HTMLButtonElement, SidebarMenuProps>(
  ({ menuItemName, menuIcon, menuItemPagePath, ...rest }, ref) => {
    // ---------------------------- HOOKS ---------------------------- //
    const pathName = usePathname();
    const router = useRouter();

    // ---------------------------- CONST ---------------------------- //
    const selectedMenu = pathName.startsWith(menuItemPagePath);

    return (
      <Button
        ref={ref}
        {...rest}
        variant={"outline"}
        className={` flex lg:justify-start transition-all flex-1 lg:flex-none gap-2 lg:p-2 ${selectedMenu ? "text-lewk-primary lg:text-white lg:bg-lewk-primary " : "text-white lg:text-black "}`}
        onClick={() => router.push(menuItemPagePath)}
      >
        <div className=" size-6">{menuIcon}</div>
        <p>{menuItemName}</p>
      </Button>
    );
  }
);

export { SidebarMenu };
